export const LOAD_NOTIFICATIONS = "LOAD_NOTIFICATIONS";
export const SAVE_PRODUCT_SELECTED = "SAVE_PRODUCT_SELECTED";
export const FLAG_LOADING = "FLAG_LOADING";
export const SAVE_BILL_TO_PRINT="SAVE_BILL_TO_PRINT";
export const SAVE_DATA_USER="SAVE_DATA_USER";
